(function () {
  'use strict';

  var BREVO_KEY    = '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';
  var SENDER_EMAIL = 'bverma@ideastradingcenter.com';
  var SENDER_NAME  = 'Ideas Trading Center';
  var BHARAT_EMAIL = 'bverma@ideastradingcenter.com';
  var ITC_LOGO     = 'https://cdn.shopify.com/s/files/1/0671/0240/8918/files/Final-Logo_aeab20d7-5efa-4d40-97b9-57e7493aa302.png?v=1730915441';

  var ROW_OVERRIDE = {
    '1-1':  { suffix: '0126', prefix: 'ITC-INT-' },
    '2-1':  { suffix: '1225', prefix: 'ITC-INT-' },
    '3-1':  { suffix: '0126', prefix: 'ITC-INT-' },
    '4-1':  { suffix: '0126', prefix: 'ITC-INT-' },
    '5-1':  { suffix: '1225', prefix: 'ITC-INT-' },
    '5-2':  { suffix: '0126', prefix: 'ITC-INT-' },
    '6-1':  { suffix: '1225', prefix: 'ITC-INT-' },
    '7-1':  { suffix: '1225', prefix: 'ITC-INT-' },
    '8-1':  { suffix: '1225', prefix: 'ITC-INT-' },
    '9-1':  { suffix: '0505', prefix: 'ITC-IDEA-' },
    '9-2':  { suffix: '0505', prefix: 'ITC-IDEA-' },
    '9-3':  { suffix: '1225', prefix: 'ITC-INT-' },
    '10-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '10-2': { suffix: '1225', prefix: 'ITC-INT-' },
    '11-1': { suffix: '1225', prefix: 'ITC-INT-' },
    '12-1': { suffix: '1225', prefix: 'ITC-INT-' },
    '14-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '15-1': { suffix: '1225', prefix: 'ITC-INT-' },
    '16-1': { suffix: '1225', prefix: 'ITC-INT-' },
    '17-1': { suffix: '1225', prefix: 'ITC-INT-' },
    '19-1': { suffix: '1225', prefix: 'ITC-INT-' },
    '20-1': { suffix: '1225', prefix: 'ITC-INT-' },
    '21-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '22-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '23-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '24-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '25-1': { suffix: '1225', prefix: 'ITC-INT-' },
    '25-2': { suffix: '1225', prefix: 'ITC-INT-' },
    '25-3': { suffix: '0126', prefix: 'ITC-INT-' },
    '26-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '27-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '28-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '29-1': { suffix: '1225', prefix: 'ITC-INT-' },
    '30-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '31-1': { suffix: '0326', prefix: 'ITC-INT-' },
    '32-1': { suffix: '0326', prefix: 'ITC-INT-' },
    '33-1': { suffix: '0326', prefix: 'ITC-INT-' },
    '35-1': { suffix: '0326', prefix: 'ITC-INT-' },
    '36-1': { suffix: '0326', prefix: 'ITC-INT-' },
    '38-1': { suffix: '0326', prefix: 'ITC-INT-' },
    '39-1': { suffix: '0326', prefix: 'ITC-INT-' },
    '40-1': { suffix: '1225', prefix: 'ITC-INT-' },
    '41-1': { suffix: '0326', prefix: 'ITC-INT-' },
    '42-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '42-2': { suffix: '1225', prefix: 'ITC-INT-' },
    '42-3': { suffix: '1225', prefix: 'ITC-INT-' },
    '42-4': { suffix: '0126', prefix: 'ITC-INT-' },
    '42-5': { suffix: '1225', prefix: 'ITC-INT-' },
    '42-6': { suffix: '0326', prefix: 'ITC-INT-' },
    '43-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '44-1': { suffix: '0126', prefix: 'ITC-INT-' },
    '45-1': { suffix: '0126', prefix: 'ITC-INT-' }
  };

  document.addEventListener('DOMContentLoaded', function () {

    var tables = document.querySelectorAll('table.collection-table');
    tables.forEach(function (table) {
      var classNum = table.getAttribute('data-class');
      if (!classNum) return;

      var dataRows = table.querySelectorAll('tr.collection-table-row');
      var rowIndex = 0;

      dataRows.forEach(function (row) {
        var itcCell = row.querySelector('td.itc-auto');
        if (!itcCell) return;

        rowIndex++;
        var paddedClass  = classNum.padStart(2, '0');
        var paddedRow    = String(rowIndex).padStart(3, '0');
        var overrideKey  = parseInt(classNum, 10) + '-' + rowIndex;
        var override     = ROW_OVERRIDE[overrideKey];

        var itcNumber;
        if (override) {
          itcNumber = override.prefix + paddedClass + paddedRow + '-' + override.suffix;
        } else {
          itcNumber = 'ITC-INT-' + paddedClass + paddedRow + '-XXXX';
          console.warn('ITC: No override found for key:', overrideKey);
        }

        itcCell.innerHTML = '<span><b>' + itcNumber + '</b></span>';
      });
    });

    var overlay    = document.getElementById('itc-popup-overlay');
    var closeBtn   = document.getElementById('itc-popup-close');
    var submitBtn  = document.getElementById('itc-submit-btn');
    var bodyDiv    = document.getElementById('itc-popup-body');
    var successDiv = document.getElementById('itc-success-msg');
    var errorDiv   = document.getElementById('itc-error-msg');
    var itcTag     = document.getElementById('itc-popup-itcnum-tag');

    if (!overlay || !submitBtn) {
      console.warn('ITC Popup: popup markup not found on page.');
      return;
    }

    var pdfUrl   = '';
    var ppaTitle = '';
    var itcNum   = '';

    var titleLinks = document.querySelectorAll('td.idea-title a');
    titleLinks.forEach(function (link) {
      // ── ACQUISITION AGREEMENT AUTO-FILL ──────────────────────────
var buyLinks = document.querySelectorAll('td.idea-buy a');
buyLinks.forEach(function (link) {
  link.addEventListener('click', function (e) {
    e.preventDefault();

    var row    = link.closest('tr');
    var itcTd  = row ? row.querySelector('td.itc-auto') : null;
    var titleTd = row ? row.querySelector('td.idea-title') : null;

    var itcNum   = itcTd   ? (itcTd.innerText   || itcTd.textContent   || '').trim() : '';
    var ppaTitle = titleTd ? (titleTd.innerText  || titleTd.textContent || '').trim() : '';

    // Class info — table ka data-class attribute se
    var table    = link.closest('table');
    var classNum = table ? table.getAttribute('data-class') : '';

    // Class name — section header se (h4 tag)
    var section   = table ? table.closest('.shopify-section') : null;
    var h4        = section ? section.querySelector('h4') : null;
    var className = h4 ? (h4.innerText || h4.textContent || '').trim() : '';
    // "Class 9: Electrical and Scientific Apparatus" format hai
    // sirf class name chahiye
    var classLabel = classNum ? ('Class ' + classNum + ': ' + className.replace(/^Class\s*\d+\s*:\s*/i, '').trim()) : className;

    var params = new URLSearchParams({
      ppa_class:  classLabel,
      ppa_number: itcNum,
      ppa_title:  ppaTitle
    });

    var baseUrl = link.getAttribute('href') || '/pages/confidential-acquisition-agreement';
    window.location.href = baseUrl + '?' + params.toString();
  });
});
      var href  = link.getAttribute('href') || '';
      var title = (link.textContent || link.innerText || '').trim();
      var row   = link.closest('tr');
      var itcTd = row ? row.querySelector('td.itc-auto') : null;
      var itc   = itcTd ? (itcTd.innerText || itcTd.textContent || '').trim() : '';

      link.addEventListener('click', function (e) {
        e.preventDefault();
        openPopup(href, title, itc);
      });
      link.style.cursor = 'pointer';
    });

    function openPopup(url, title, itc) {
      pdfUrl   = url;
      ppaTitle = title;
      itcNum   = itc;
      itcTag.textContent = itc + ' | ' + title;
      document.getElementById('itc-name').value    = '';
      document.getElementById('itc-company').value = '';
      document.getElementById('itc-email').value   = '';
      errorDiv.style.display   = 'none';
      successDiv.style.display = 'none';
      bodyDiv.style.display    = 'block';
      submitBtn.disabled       = false;
      submitBtn.textContent    = 'Request Abstract';
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        document.getElementById('itc-name').focus();
      }, 250);
    }

    function closePopup() {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    function onSuccess() {
      bodyDiv.style.display    = 'none';
      successDiv.style.display = 'block';
      setTimeout(function () {
        window.open(pdfUrl, '_blank');
        setTimeout(closePopup, 1500);
      }, 1200);
    }

    function showError(msg) {
      errorDiv.textContent   = msg;
      errorDiv.style.display = 'block';
    }

    closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    submitBtn.addEventListener('click', function () {
      var name    = document.getElementById('itc-name').value.trim();
      var company = document.getElementById('itc-company').value.trim();
      var email   = document.getElementById('itc-email').value.trim();

      if (!name || !company || !email) {
        showError('Please fill in all required fields.');
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showError('Please enter a valid email address.');
        return;
      }

      errorDiv.style.display = 'none';
      submitBtn.disabled     = true;
      submitBtn.textContent  = 'Submitting...';

      var userEmailBody = ''
        + '<html><body style="margin:0;padding:0;font-family:Georgia,serif;">'
        + '<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:auto;border:1px solid #e8e8e8;">'
        + '<tr><td style="background:#1a1a2e;padding:18px 24px;text-align:center;">'
        + '<img src="' + ITC_LOGO + '" alt="ITC" style="height:50px;margin-bottom:8px;"><br>'
        + '<span style="color:#fff;font-size:16px;font-weight:700;">Requested Abstract</span>'
        + '</td></tr>'
        + '<tr><td style="padding:24px 28px;color:#333;font-size:14px;line-height:1.7;">'
        + '<p>Dear ' + name + ',</p>'
        + '<p>Thank you for your request to review the abstract for the following filed Provisional Patent Application (PPA):</p>'
        + '<table style="width:100%;margin:12px 0;border-collapse:collapse;">'
        + '<tr><td style="padding:8px 12px;background:#f5f7fa;border:1px solid #e8e8e8;font-size:13px;color:#333;">'
        + '<b style="color:#1a1a2e;">ITC #:</b> ' + itcNum + '</td></tr>'
        + '<tr><td style="padding:8px 12px;background:#fff;border:1px solid #e8e8e8;font-size:13px;color:#333;">'
        + '<b style="color:#1a1a2e;">PPA Title:</b> ' + ppaTitle + '</td></tr></table>'
        + '<p>The abstract is now available for your review.</p>'
        + '<p>If this opportunity is of interest, access to the full PPA can be provided under ITC\'s standard evaluation process upon execution of a one-way non-disclosure agreement.</p>'
        + '<p style="margin-top:20px;">Best regards,<br><b>Bharat Verma</b><br>'
        + '<span style="font-size:13px;color:#666;">President<br>Ideas Trading Center LLC</span></p>'
        + '</td></tr>'
        + '<tr><td style="background:#f5f7fa;padding:14px 24px;text-align:center;border-top:1px solid #e8e8e8;">'
        + '<p style="margin:0;font-size:11px;color:#999;">&copy; Ideas Trading Center - New Jersey, USA</p>'
        + '</td></tr></table></body></html>';

      var itcEmailBody = ''
        + '<html><body style="font-family:Georgia,serif;color:#333;font-size:14px;line-height:1.6;">'
        + '<h3 style="color:#1a1a2e;">New Abstract Request Received</h3>'
        + '<table style="border-collapse:collapse;width:100%;max-width:500px;">'
        + '<tr><td style="padding:6px 10px;font-weight:bold;border:1px solid #ddd;">Name</td>'
        + '<td style="padding:6px 10px;border:1px solid #ddd;">' + name + '</td></tr>'
        + '<tr><td style="padding:6px 10px;font-weight:bold;border:1px solid #ddd;">Company</td>'
        + '<td style="padding:6px 10px;border:1px solid #ddd;">' + company + '</td></tr>'
        + '<tr><td style="padding:6px 10px;font-weight:bold;border:1px solid #ddd;">Email</td>'
        + '<td style="padding:6px 10px;border:1px solid #ddd;">' + email + '</td></tr>'
        + '<tr><td style="padding:6px 10px;font-weight:bold;border:1px solid #ddd;">PPA Title</td>'
        + '<td style="padding:6px 10px;border:1px solid #ddd;">' + ppaTitle + '</td></tr>'
        + '<tr><td style="padding:6px 10px;font-weight:bold;border:1px solid #ddd;">ITC #</td>'
        + '<td style="padding:6px 10px;border:1px solid #ddd;">' + itcNum + '</td></tr>'
        + '</table></body></html>';

      var sendUserEmail = fetch('https://api.brevo.com/v3/smtp/email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'api-key': BREVO_KEY },
        body: JSON.stringify({
          sender: { name: SENDER_NAME, email: SENDER_EMAIL },
          to: [{ email: email, name: name }],
          subject: 'Your Requested Abstract - ' + itcNum,
          htmlContent: userEmailBody
        })
      });

      var sendItcEmail = fetch('https://api.brevo.com/v3/smtp/email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'api-key': BREVO_KEY },
        body: JSON.stringify({
          sender: { name: 'ITC Website', email: SENDER_EMAIL },
          to: [{ email: BHARAT_EMAIL, name: 'Bharat Verma' }],
          subject: 'New Abstract Request - ' + itcNum,
          htmlContent: itcEmailBody
        })
      });

      // FIXED: Ab error properly dikhega agar mail fail ho
      Promise.all([sendUserEmail, sendItcEmail])
        .then(function (responses) {
          var allOk = responses.every(function (r) { return r.ok; });
          if (allOk) {
            onSuccess();
          } else {
            submitBtn.disabled    = false;
            submitBtn.textContent = 'Request Abstract';
            showError('Email could not be sent. Please try again.');
          }
        })
        .catch(function () {
          submitBtn.disabled    = false;
          submitBtn.textContent = 'Request Abstract';
          showError('Network error. Please check your connection and try again.');
        });
    });

    document.querySelectorAll('td.idea-title').forEach(function (td) {
      td.addEventListener('contextmenu', function (e) {
        e.preventDefault();
      });
    });

  });
})();